<template>
  <div class="sidebar-details">
    <div class="sidebar-details-header">
      <div
        class="sidebar-details-close"
        v-on:click="
                  $store.dispatch('backDetails');
                  $parent.showModalCalc=false;"
      >
        <i class="far fa-arrow-alt-circle-left"></i>
      </div>
      <div class="sidebar-details-main-title">{{ properties.nazwa | showInLang(currlang) }}</div>
    </div>
    <div class="sidebar-details-body" v-if="!offer">
      <Loading />
    </div>
    <div class="sidebar-details-body" v-else>
      <div class="sidebar-details-image">
        <div @click="openLightbox">
          <b-carousel id="carousel1" controls :interval="2000" v-model="carouselIndex">
            <template v-for="(url, index) in CarouselImages">
              <b-carousel-slide
                :key="index"
                :img-src="url.path + '?thumb=1'"
                @click="openLightbox"
              ></b-carousel-slide>
            </template>
          </b-carousel>
        </div>
      </div>
      <div class="sidebar-details-first-info">
        <div class="sidebar-details-area-label">{{ $t("nav.infoPanel.surface") }}</div>
        <div
          class="sidebar-details-area-value"
        >{{ properties.powierzch | roundTo4Places | showInLangField(currlang) }} {{ $t('nav.infoPanel.hectare') }}</div>
      </div>

      <SidebarDetailsOptions
        :panoramaUrl="panoramaUrl"
        :coordinates="this.properties.centroid_geometry.coordinates"
        @pdf="showDownloadFileItem()"
        @calc="$parent.openModalCalc()"
      />

      <div class="sidebar-details-informations" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.localization") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.infoPanel.address") }}</td>
              <td>{{ properties.adres | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.city") }}</td>
              <td>{{ properties.miejscowosc | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.community") }}</td>
              <td>{{ properties.gmina_nazwa | removeCommunityName | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.district") }}</td>
              <td>{{ properties.powiat_nazwa | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.voivodeship") }}</td>
              <td>{{ properties.wojewodztwo_nazwa | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.gps") }}</td>
              <td>{{ gpsLocation }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.link") }}</td>
              <td>
                <div
                  v-if="properties.mymaps_url && properties.mymaps_url.length"
                  class="mymapsHref"
                >
                  <a
                    :href="properties.mymaps_url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ properties.mymaps_url | showInLangField(currlang) }}</a>
                </div>
                <div v-else>{{ properties.mymaps_url | showInLangField(currlang) }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-contact" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.contactPerson") }}</div>
        <div class="sidebar-details-contact-item">
          <div
            class="sidebar-details-contact-avatar"
            v-if="properties.os_kontakt_avatar && properties.os_kontakt_avatar.length"
          >
            <img
              :src="$parent.imgToSrc(properties.os_kontakt_avatar)"
              :alt="properties.os_kontakt_avatar"
            />
          </div>
          <div v-else>{{ properties.os_kontakt_avatar | showInLangAvatar(currlang) }}</div>
          <div class="sidebar-details-contact-info">
            <div
              class="sidebar-details-contact-info-name"
            >{{ $t("nav.infoPanel.firstname") }} {{ properties.os_kontakt_imie | showInLangField(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-name"
            >{{ $t("nav.infoPanel.surname") }} {{ properties.os_kontakt_nazwisko | showInLangField(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-text"
            >{{ $t("nav.infoPanel.position") }} {{ properties.os_kontakt_stanowisko | showInLang(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-text"
            >{{ $t("nav.infoPanel.department") }} {{ properties.os_kontakt_departament | showInLang(currlang) }}</div>
            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.infoPanel.telOffice") }}
              <a
                :href="'tel:' + properties.os_kontakt_tel_biur"
              >{{ properties.os_kontakt_tel_biur | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.infoPanel.tel") }}
              <a
                :href="'tel:' + properties.os_kontakt_tel_kom"
              >{{ properties.os_kontakt_tel_kom | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-mail">
              {{ $t("nav.infoPanel.email") }}
              <a
                :href="'mailto:' + properties.os_kontakt_email"
              >{{ properties.os_kontakt_email | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-options">
              <div
                class="sidebar-details-contact-info-options-item pdf"
                v-tooltip.auto="$t('tooltip.savePDF')"
              >
                <img src="img/pdf_icon.svg" />
              </div>
              <div
                class="sidebar-details-contact-info-options-item qrcode"
                v-tooltip.auto="$t('tooltip.qrcode')"
                @click="$modal.show('qrcode-modal')"
              >
                <img src="img/qr_code_icon.svg" />
              </div>
              <div class="sidebar-details-contact-info-options-item degrees">
                <img src="img/question_mark_icon.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-details-informations" v-show="properties.status == 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.ibc") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcName") }}</td>
              <td>{{ properties.nazwa | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcNIP") }}</td>
              <td>{{ properties.inw_nip | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcREGON") }}</td>
              <td>{{ properties.inw_regon | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcTrade") }}</td>
              <td>{{ properties.inw_branza | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcCore") }}</td>
              <td>{{ properties.inw_dzialalnosc | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcAddress") }}</td>
              <td>{{ properties.inw_adres | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcZIP") }}</td>
              <td>{{ properties.przedsieb_miejscowosc | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcTel") }}</td>
              <td>{{ properties.przedsieb_os_tel_kom | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcFAX") }}</td>
              <td>{{ properties.przedsieb_fax | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ibcEmail") }}</td>
              <td>{{ properties.przedsieb_email | showInLangField(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-informations" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.generalInfo") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.infoPanel.surface") }}</td>
              <td>{{ properties.powierzch | roundTo4Places | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.realEstate") }}</td>
              <td>{{ (properties.numery_dzialek || []).join(", ") }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.owner") }}</td>
              <td>{{ properties.wlasciciel | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.MPZP") }}</td>
              <td>{{ properties.mpzp | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.MPZPDestiny") }}</td>
              <td>{{ properties.mpzp_przeznaczenie | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.suikzp") }}</td>
              <td>{{ properties.skiuzp | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.MPZPPercentage") }}</td>
              <td>{{ properties.proc_dopuszczalnej_zabud | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.MPZPMaxHeight") }}</td>
              <td>{{ properties.maks_wys_bud | showInLangField(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-informations" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.infrastructure") }}</div>

        <button
          class="wide-button nice-blue-background"
          @click="$modal.show('modal-infrastructure-details', {oferta: offer});"
        >{{ $t("nav.infoPanel.details") }}</button>
      </div>

      <div class="sidebar-details-informations" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-title">{{ $t("nav.infoPanel.communication") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.infoPanel.RealEstateRoadAccess") }}</td>
              <td>{{ properties.kom_dostep_do_drogi | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DirectAccessRoad") }}</td>
              <td>{{ properties.kom_bezposredni_dojazd | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DirectAccessRoadType") }}</td>
              <td>{{ properties.kom_typ_drogi_dojazd | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DirectAccessRoadTypeSurface") }}</td>
              <td>{{ properties.kom_nawierzchnia_dojazd | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DirectAccessRoadWidth") }}</td>
              <td>{{ properties.kom_szerokosc_dojazd | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.ExpansionRoadInfrastructure") }}</td>
              <td>{{ properties.kom_rozbudowa | showInLang(currlang) }}</td>
            </tr>

            <tr>
              <td>{{ $t("nav.infoPanel.NearestHighwayExpressway") }}</td>
              <td>{{ properties.autostrada_najbliz | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceHighwayExpressway") }}</td>
              <td>{{ properties.autostrada_odl | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.NearestNationalRoad") }}</td>
              <td>{{ properties.krajowa_najbliz | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceNationalRoad") }}</td>
              <td>{{ properties.krajowa_odl }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.RiverSeaPorts") }}</td>
              <td>{{ properties.porty | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.RailwayLine") }}</td>
              <td>{{ properties.kolej | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromRailwayLine") }}</td>
              <td>{{ properties.kolej_odl | showInLangField(currlang) }}</td>
            </tr>

            <tr>
              <td>{{ $t("nav.infoPanel.ExistingRailwaySiding") }}</td>
              <td>{{ properties.bocznica | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromRailwaySiding") }}</td>
              <td>{{ properties.bocznica_odl | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.PossibilityBuildingRailwaySiding") }}</td>
              <td>{{ properties.bocznica_mozliwa | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromFreightStation") }}</td>
              <td>{{ properties.dworz_towarowy_odl | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromPassengerStation") }}</td>
              <td>{{ properties.dworz_osobowy_odl | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.NearestInternationalAirports") }}</td>
              <td>{{ properties.lotniska | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromInternationalAirports") }}</td>
              <td>{{ properties.lotnisko_odl | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.NearestProvincialCity") }}</td>
              <td>{{ properties.miasto_woj | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.infoPanel.DistanceFromProvincialCity") }}</td>
              <td>{{ properties.miasto_woj_odl | showInLangField(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div
        class="sidebar-details-informations"
        v-if="outlays !== undefined && properties.status != 'zainwest'"
      >
        <div class="sidebar-details-subtitle">{{ $t("nav.infoPanel.mie") }}</div>
        <div class="sidebar-details-subtitlemini">{{ $t("nav.infoPanel.industrialEnterprise") }}</div>
        <div class="sidebar-details-mni">
          <div
            class="sidebar-details-mni-item"
            v-for="(item, index) in outlays.filter(f => f.sektor === 'przemysl')"
            :key="index"
          >
            <img
              class="ikona-firmy"
              :src="`img/${IKONY_FIRMY[item.wielkosc_przedsiebiorstwa]}.png`"
            />
            <div class="sidebar-details-mni-info">
              <div
                class="sidebar-details-mni-label"
              >{{ item.wielkosc_przedsiebiorstwa | outlaysEnterprise(currlang) }}</div>
              <div class="sidebar-details-mni-value">{{ item.naklady }} PLN</div>
            </div>
          </div>
        </div>

        <div class="sidebar-details-subtitlemini with-q">{{ $t("nav.infoPanel.serviceCompany") }}</div>
        <div class="sidebar-details-mni">
          <div
            class="sidebar-details-mni-item"
            v-for="(item, index) in outlays.filter(f => f.sektor === 'uslugi')"
            :key="index"
          >
            <img
              class="ikona-firmy"
              :src="`img/${IKONY_FIRMY[item.wielkosc_przedsiebiorstwa]}.png`"
            />
            <div class="sidebar-details-mni-info">
              <div
                class="sidebar-details-mni-label"
              >{{ item.wielkosc_przedsiebiorstwa | outlaysEnterprise(currlang) }}</div>
              <div class="sidebar-details-mni-value">{{ item.naklady }} PLN</div>
            </div>
          </div>
        </div>
      </div> -->

      <div
        class="sidebar-details-informations"
        style="margin-bottom: 20px"
        v-if="outlays !== undefined && properties.status != 'zainwest'"
      >
        <div class="sidebar-details-title" style="margin-top: 20px">{{ $t("nav.infoPanel.taxReliefCalc") }}</div>
        <div class="sidebar-details-taxReliefSubtitle">{{ $t("nav.infoPanel.taxReliefCalcSubtitle") }}</div>
        <div class="sidebar-details-taxReliefSubtitle">{{ $t("nav.infoPanel.taxReliefCalcSubtitle2") }}:</div>
        <div class="sidebar-details-taxReliefLink">
           <a target="_blank" href="https://invest-park.com.pl/ulgi-i-zwolnienia">{{ $t("nav.infoPanel.goToCalc") }}</a> 
        </div>
      </div>

      <div class="sidebar-details-informations" v-show="properties.status != 'zainwest'">
        <div class="sidebar-details-ann">
          <div class="sidebar-details-ann-text">{{ $t("nav.infoPanel.add1") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.ikona-firmy {
  height: 24px;
}
</style>


<script>
import moment from "moment";

import SidebarDetailsOptions from "./SidebarDetailsOptions";

const IKONY_FIRMY = {
  duze: "firmy_duze",
  srednie: "firmy_srednie",
  male: "firmy_male_mikro",
  mikro: "firmy_male_mikro"
};

export default {
  components: {
    SidebarDetailsOptions
  },
  data() {
    return {
      carouselIndex: 0,
      outlays: []
    };
  },
  computed: {
    IKONY_FIRMY: () => IKONY_FIRMY,
    offer() {
      return this.$store.getters.currentOferta;
    },
    properties() {
      return (this.offer && this.offer.properties) || {};
    },
    currlang() {
      return this.$parent.currlang;
    },
    panoramaUrl: function() {
      return (
        "http://panorama.invest-park.com.pl/?gps=" +
        this.offer.properties.formatka_prywatna_id
      );
    },
    gpsLocation() {
      if (this.properties.centroid_geometry) {
        let c = this.properties.centroid_geometry.coordinates;
        return [c[1], c[0]].join(", ");
      } else {
        return undefined;
      }
    },
    openLightbox() {
      return () => {this.$parent.openLightbox(this.properties.zdjecia, this.carouselIndex)};
    },
    CarouselImages() {
      let CarouselImages = [];
      let zdjecia = this.properties.zdjecia || [];
      if (zdjecia.length == 0) {
        CarouselImages.push({
          path: "img/invest_park_logo_big.png"
        });
      }
      zdjecia.forEach(pathImg => {
        CarouselImages.push({
          path: this.$parent.imgToSrc(pathImg)
        });
      });
      return CarouselImages;
    }
  },
  watch: {
    offer: {
      immediate: true,
      handler(offer) {
        if (offer) {
          this.getInvestOutlays(offer.properties.gmina_id);
        }
      }
    }
  },
  methods: {
    showDownloadFileItem() {
      window.open(
        [
          `${process.env.VUE_APP_API_URL}`,
          `${
            this.offer.properties.status === "zainwest"
              ? "formatka_zainwest"
              : "formatka_paih"
          }`,
          `${this.offer.id}`,
          `oferta-${this.offer.id}_${moment().format("YYYY-MM-DD_hhmmss")}.pdf`
        ].join("/")
      );
    },
    getInvestOutlays(id) {
      this.$http.get(`/naklady_inwestycyjne/gmina/${id}`, {
        params: {
          'gmina_traci_funkcje': this.properties.gmina_traci_funkcje,
        }
      }).then(
        r => {
          this.outlays = r.data.items;
        },
        () => {
          this.outlays = undefined;
        }
      );
    }
  }
};
</script>
